import React from 'react'
const Button = (props:any) => {
    const {children}=props

  return (
    <button style={{borderRadius:"5px"}} className="className='button button--outline button--fit button--sm " >{children}</button>
  )
}

// className="button button--solid button--fit button--sm"   Note: this was removed from the button class
export default Button